<div class='waiting' [ngClass]="{hidden: !_sponsorService.spinner}">
  <mat-spinner diameter="60"></mat-spinner>
</div>

<div class="container">

  <app-header-dialog [iconName]="'monetization_on'">
    {{ local_title }}
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>monetization_on</mat-icon>
          <div>Patrocinador</div>
        </ng-template>

        <div class='tab-content-id'>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>URL</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.url"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.url.hasError('required')">
              A URL é obrigatória
            </mat-error>
          </mat-form-field>



          <div class='img-input'>
            <input #file type="file" accept='image/png, image/jpg' style='display:none;'
              (change)="_sponsorService.previewImage($event)" />

            <button mat-raised-button (click)='file.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>

          </div>

          <div class="img-input-display">
            <img [src]="_sponsorService.storedImage" *ngIf="_sponsorService.storedImage">
          </div>

        </div>

      </mat-tab>

    </mat-tab-group>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>